/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="73.26"
        height="84.13"
        viewBox="0 0 73.26 84.13"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M21.62 32.41a1.25 1.25 0 0 1 0 2.5 6.79 6.79 0 0 0-1.9.25c-6.32 1.75-9.72 11.76-7.08 21.9a1.25 1.25 0 0 1-.9 1.53 1.24 1.24 0 0 1-1.52-.9c-3-11.31 1-22.76 8.83-24.94a9.65 9.65 0 0 1 2.57-.34ZM52.03 4.75a1.25 1.25 0 0 1 0 2.5A14.14 14.14 0 0 0 37.9 21.01v6.38a1.26 1.26 0 0 1-1.28 1.23 1.24 1.24 0 0 1-1.21-1.1v-6.2A16.64 16.64 0 0 1 52.03 4.75Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="m36.64 29.27-.14-.11c-6-5.14-13.17-7.17-19.91-5.3C3.83 27.39-2.97 43.61 1.26 60.01s18 27 30.8 23.43l.5-.14a19.7 19.7 0 0 0 3.82-1.68l.24-.15.25.15a19 19 0 0 0 4.31 1.82c12.82 3.55 26.55-7 30.81-23.43S69.5 27.39 56.7 23.85c-6.74-1.87-13.94.16-19.91 5.3Zm19.39-3c11.33 3.14 17.5 17.93 13.56 33.12S53.18 84.17 41.83 81.01a15.9 15.9 0 0 1-4.55-2.08 1.31 1.31 0 0 0-1.35 0 16.3 16.3 0 0 1-4.55 2.08C20.07 84.14 7.6 74.53 3.66 59.36s2.23-30 13.55-33.12c6.23-1.73 13 .37 18.54 5.62a1.25 1.25 0 0 0 1.71 0c5.56-5.26 12.31-7.35 18.53-5.62Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M21.26.01h-3.84a1.25 1.25 0 0 0-1.25 1.25V5.1a16.62 16.62 0 0 0 16.6 16.66h3.87a1.24 1.24 0 0 0 1.25-1.25v-3.87A16.64 16.64 0 0 0 21.26.01Zm-2.6 2.5h2.91a14.14 14.14 0 0 1 13.82 14.13v2.6h-2.56A14.13 14.13 0 0 1 18.7 5.1Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'AppleWithStemIcon';

export default Icon;
